import React from 'react';
import { marqueeItems } from '../data';

export default function Marquee() {
  const doubled = [...marqueeItems, ...marqueeItems];
  return (
    <div className="marquee-wrapper py-4 border-y" style={{borderColor:'rgba(200,168,75,0.12)',background:'rgba(200,168,75,0.02)'}}>
      <div className="marquee-content">
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center gap-4 flex-shrink-0">
            <span style={{color:'rgba(212,207,197,0.4)',fontSize:'0.72rem',letterSpacing:'3px',textTransform:'uppercase',fontFamily:'Space Mono,monospace'}}>
              {item}
            </span>
            <span style={{color:'#C8A84B',fontSize:'0.6rem'}}>✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
